import { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { Button, TextField } from "@mui/material";
import "./VerificationField.css";
import { submitContactVerification } from "../Store/Actions/OutboundAction";

export default function VerificationField({
  detailTSS,
  index,
  inputParam,
  isVerificationFieldsLocked,
  label,
  setIsVerificationFieldsLocked,
  setVerifiedFields,
  submittedValues,
  verifiedFields,
}) {
  const [attempt, setAttempt] = useState(
    submittedValues[`${inputParam.toLowerCase()}verifattempt`] ?? 0
  );

  const [isVerifying, setIsVerifying] = useState(false);

  const [status, setStatus] = useState(
    submittedValues[`${inputParam.toLowerCase()}verifresult`] ?? "NOTPASSED"
  );

  const [value, setValue] = useState(
    submittedValues[`${inputParam.toLowerCase()}verifvalue`] ?? ""
  );

  function isVerifyDisabled() {
    if (!value || isVerifying || status === "PASSED" || status === "BLOCKED") {
      return true;
    } else if (index === 0) {
      return false;
    } else if (isVerificationFieldsLocked) {
      return true;
    } else {
      return false;
    }
  }

  function verify() {
    setIsVerifying(true);

    submitContactVerification({
      inputvalue:
        inputParam === "DOB" ? moment(value).format("DD-MM-YYYY") : value,

      inputparam: inputParam,
      contactid: detailTSS.assignment.contactid,
      campaignid: detailTSS.assignment.campaignid,
      contactVerif: detailTSS.contactVerif,
    })
      .then((response) => {
        if (response.status) {
          const result = response.data[`${inputParam}verifresult`];

          if (result === "PASSED") {
            inputParam === "DOB" && setIsVerificationFieldsLocked(false);
            setStatus("PASSED");
            setVerifiedFields(verifiedFields + 1);
          } else if (result === "BLOCKED") {
            setStatus("BLOCKED");
          }

          setAttempt(attempt + 1);
          setIsVerifying(false);
        } else {
          console.log("error", response.error);

          toast.error("Error verifying information.", {
            autoClose: 3000,
          });

          setIsVerifying(false);
        }
      })
      .catch((err) => {
        console.log("err", err);

        toast.error("Error verifying information.", {
          autoClose: 3000,
        });

        setIsVerifying(false);
      });
  }

  return (
    <div
      className={`verification-field ${
        status === "PASSED" ? "verified" : status === "BLOCKED" ? "blocked" : ""
      }`}
    >
      {inputParam === "DOB" ? (
        <DatePicker
          disabled={status === "PASSED" || status === "BLOCKED"}
          disableFuture
          label={label}
          slotProps={{ textField: { fullWidth: true } }}
          value={value ? moment(value) : null}
          renderInput={(params) => <TextField {...params} />}
          onChange={(newValue) => setValue(newValue)}
        />
      ) : (
        <TextField
          disabled={
            isVerificationFieldsLocked ||
            status === "PASSED" ||
            status === "BLOCKED"
          }
          fullWidth
          label={label}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}

      <Button
        disabled={isVerifyDisabled()}
        variant="contained"
        onClick={verify}
      >
        {isVerifying
          ? "Verifying..."
          : status === "PASSED"
          ? "Verified"
          : status === "BLOCKED"
          ? "Blocked"
          : "Verify"}
      </Button>

      <p className="counter">{attempt} / 3</p>
    </div>
  );
}
